import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LANG, isLang, resources, type Lang } from '@/locales/index';
const LANG_KEY = 'sp.lang';
function storedLang(): Lang {
  try {
    const saved = localStorage.getItem(LANG_KEY);
    if (saved !== null && isLang(saved)) return saved;
  } catch {}
  return DEFAULT_LANG;
}
void i18next.use(initReactI18next).init({
  resources,
  lng: storedLang(),
  fallbackLng: 'en-US',
  interpolation: {
    escapeValue: false,
    prefix: '{{',
    suffix: '}}',
  },
});
export async function changeLang(lang: Lang): Promise<void> {
  await i18next.changeLanguage(lang);
  try {
    localStorage.setItem(LANG_KEY, lang);
  } catch {}
}
export const i18n = i18next;
